<template>
  <v-card>
    <v-card-title>
      Please, confirm next changes
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-simple-table>
            <thead>
            <tr>
              <th>Field</th>
              <th>Current</th>
              <th>New</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(diffItem, index)  in diff" :key="index">
              <td>{{ getFieldTitle(index) }}</td>
              <td>{{ diffItem[0] }}</td>
              <td>{{ diffItem[1] }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea v-model="reason" label="Reason" auto-grow outlined dense persistent-hint hint="Enter the reason for the change"></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          color="primary"
          :disabled="confirmButtonDisabled"
          :loading="confirmInProgress"
          @click="handleConfirmButtonClick">
        Confirm
      </v-btn>
      <v-btn @click="handleCancelButtonClick">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>


import _ from 'lodash'

const fieldTitlesByFields = {
  donor: 'Donor',
  comment: 'Comment',
  biopsyDate: 'Biopsy dates',
  reportDate: 'Report date',
  clientTitle: 'Clinic title',
  donorNumber: 'Donor number',
  indications: 'Clinical data',
  partnerName: 'Partner name',
  patientName: 'Patient name',
  caseSystemId: 'Case number',
  embryologist: 'Embryologists',
  partnerDonor: 'Partner donor',
  partnerBirthday: 'Partner birthday',
  clientSpecialist: 'Embryologists',
  patientExternalId: 'External Id',
  patientInternalId: 'Patient internal Id',
  partnerDonorNumber: 'Partner donor number',
  materialsReceivedDate: 'Materials received date'
}

export default {
  name: 'SnapshotDiffManager',
  props: {
    report: Object,
    confirmInProgress: Boolean,
    diff: Object,
  },
  data() {
    return {
      reason: null
    }
  },
  computed: {
    isValid() {
      if (this.reason === null) {
        return false
      }

      const reasonTrimmed = _.trim(this.reason)

      return reasonTrimmed.length > 5
    },
    confirmButtonDisabled() {
      return this.confirmInProgress || !this.isValid
    }
  },
  methods: {
    getFieldTitle(field) {
      return _.get(fieldTitlesByFields, field, field)
    },
    handleConfirmButtonClick() {
      this.$emit('confirm', {
        reason: _.cloneDeep(this.reason)
      })
    },
    handleCancelButtonClick() {
      this.$emit('cancel')
      this.clear()
    },
    clear() {
      this.reason = null
    }
  }
}
</script>

<style scoped>

</style>